import { cn, io } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';

import { getCtaButtonShade } from '../lib/helpers';

const Footer = ({
  footerActions,
  size,
  color,
  variant,
  footerLoadingStates = {},
  handleFooterActionClick
}) => {
  if (!io(footerActions?.primary) && !io(footerActions?.secondary) && !io(footerActions?.tertiary))
    return null;

  return (
    <div className={cn('flex h-fit items-center gap-2', size === 'large' && 'mt-3 flex-wrap')}>
      {io(footerActions.primary) && (
        <Button
          {...footerActions.primary}
          size="xs"
          text={footerActions.primary.text}
          isLoading={footerLoadingStates.primary || footerActions.primary.isLoading}
          isDisabled={footerActions.primary.isDisabled || footerLoadingStates.primary}
          color={color}
          shade={getCtaButtonShade(color, variant)}
          data-qa={footerActions.primary['data-qa']}
          onClick={() =>
            handleFooterActionClick(
              footerActions.primary.onClick,
              'primary',
              footerActions.primary.closeOnClick
            )
          }
        />
      )}
      {io(footerActions.secondary) && (
        <>
          {io(footerActions.primary) && (
            <span
              className={cn(
                'text-[8px]',
                variant === 'filled' ? 'text-white' : 'text-neutral-500'
              )}>
              •
            </span>
          )}
          <Button
            {...footerActions.secondary}
            size="xs"
            variant="link"
            color={variant === 'filled' ? 'white' : 'neutral'}
            textClassName="underline"
            shade={900}
            text={footerActions.secondary.text}
            data-qa={footerActions.secondary['data-qa']}
            isLoading={footerLoadingStates.secondary || footerActions.secondary.isLoading}
            isDisabled={footerActions.secondary.isDisabled || footerLoadingStates.secondary}
            {...footerActions.secondary}
            onClick={() =>
              handleFooterActionClick(
                footerActions.secondary.onClick,
                'secondary',
                footerActions.secondary.closeOnClick
              )
            }
          />
        </>
      )}
      {io(footerActions.tertiary) && (
        <>
          {(io(footerActions.primary) || io(footerActions.secondary)) && (
            <span
              className={cn(
                'text-[8px]',
                variant === 'filled' ? 'text-white' : 'text-neutral-500'
              )}>
              •
            </span>
          )}
          <Button
            {...footerActions.tertiary}
            size="xs"
            variant="link"
            color={variant === 'filled' ? 'white' : 'neutral'}
            shade={900}
            text={footerActions.tertiary.text}
            data-qa={footerActions.tertiary['data-qa']}
            isLoading={footerLoadingStates.tertiary || footerActions.tertiary.isLoading}
            isDisabled={footerActions.tertiary.isDisabled || footerLoadingStates.tertiary}
            onClick={() =>
              handleFooterActionClick(
                footerActions.tertiary.onClick,
                'tertiary',
                footerActions.tertiary.closeOnClick
              )
            }
          />
        </>
      )}
    </div>
  );
};

export default Footer;
